const NullRatingInfo = { count: 0, score: undefined };

export default NullRatingInfo;
